import * as React from 'react';
import tombacIcon from '../tombacIcon';

function SvgGrid(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="5 0 14 24" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M19 19H5V5h14v14zM7 13v4h4v-4H7zm10 0h-4v4h4v-4zm0-6.001h-4V11h4V6.999zM7 11h4V6.999H7V11z"
      />
    </svg>
  );
}

export default tombacIcon('Grid')(SvgGrid);
